import styles from './page.module.scss';
import React, {CSSProperties} from 'react';

interface OwnProps {
    children: React.ReactNode;
    style?: CSSProperties;
}

export function PageIcon({children, style}: OwnProps) {
    return (
        <div style={style} className={styles.page__icon}>
            {children}
        </div>
    );
}
